/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Admin_CtaInputs */

const zh_landing_admin_cta = /** @type {(inputs: Landing_Admin_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费开始`)
};

const en_landing_admin_cta = /** @type {(inputs: Landing_Admin_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start for free`)
};

const es_landing_admin_cta = /** @type {(inputs: Landing_Admin_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empieza gratis`)
};

/**
* | output |
* | --- |
* | "Start for free" |
*
* @param {Landing_Admin_CtaInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const landing_admin_cta = /** @type {((inputs?: Landing_Admin_CtaInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Admin_CtaInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_admin_cta(inputs)
	if (locale === "en") return en_landing_admin_cta(inputs)
	return es_landing_admin_cta(inputs)
});